import React, { useContext } from 'react';
import { SidebarCollapseContext } from './SidebarCollapseContext';

export default function SidebarIcon({ icon, iconSrc }: { icon?: string; iconSrc?: string }) {
  const { collapsed } = useContext(SidebarCollapseContext);
  const centering = collapsed ? ' me-0 justify-content-center text-center' : '';
  return iconSrc
    ? <span className={`nav-icon d-inline-flex align-items-center${centering}`} style={{ flexBasis: '1.5rem' }}><img src={iconSrc} alt="" width={16} height={16} /></span>
    : <i className={`bi-${icon} nav-icon${centering}`} style={{ flexBasis: '1.5rem' }}></i>;
}
